



























































import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { LendingAccountModule } from '@/store/Accounts/LendingAccountModule';
import UpdateAccountGeneralProductSettingsRequest from '@/models/Accounts/Shared/UpdateAccountGeneralProductSettingsRequest';
import ProductIssueType from '@/models/Products/ProductIssues/ProductIssueType';

@Component({ name: 'ProductDetailsEditDialog' })
export default class extends SaascadaVueDialog {

    ProductIssueType = ProductIssueType;

    request: UpdateAccountGeneralProductSettingsRequest = new UpdateAccountGeneralProductSettingsRequest(null, null, null);
    productIssueSelectionType = ProductIssueType.UseCurrentIssue;

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            this.productIssueSelectionType = ProductIssueType.UseCurrentIssue;
            this.request = new UpdateAccountGeneralProductSettingsRequest(LendingAccountModule.lendingAccount.productId, LendingAccountModule.lendingAccount.productIssueId, new Date());
            LendingAccountModule.getProductOptionsForLendingAccount();
        }
    }

    @Watch('request.productId')
    async onRequestProductIdChanged(productID: string) {
        this.request.productIssueId = null;
        LendingAccountModule.getProductIssueOptionsForLendingAccount(productID);
    }

    get productOptions() {
        return LendingAccountModule.productOptions;
    }

    get productIssueOptions() {
        return LendingAccountModule.productIssueOptions;
    }

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        else {
            this.dialog = false;

            if (this.request.productIssueId === null || this.request.productIssueId === '') {
                this.request.productIssueId = undefined;
            }

            await LendingAccountModule.editGeneralProductSettings(this.request);
        }
    }

}
